import { Model } from 'vuex-orm';

import User from '../user/model';

export default class Log extends Model {
  static entity = 'logs';

  static fields() {
    return {
      id: this.attr(null),
      loggable_id: this.attr(null),
      loggable_type: this.attr(null),
      author_id: this.attr(null),
      action: this.attr(''),
      device_name: this.attr(''),
      browser_name: this.attr(''),
      os_name: this.attr(''),
      ip_address: this.attr(''),
      user_agent: this.attr(''),
      mobile: this.attr(''),
      tablet: this.attr(''),
      robot: this.attr(''),
      created_at: this.attr(''),

      author: this.belongsTo(User, 'author_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/log/model.js